export const isReady = state => state.ready;
export const isLoading = state => state.isLoading;
export const currentRoute = state => state.route;
